// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"cc00129e","167":"0c67a469","231":"ffa6cf6d","249":"f8b06398","469":"2d384da7","488":"e5b8a697","627":"a6a72050","642":"c73683c2","648":"9aa02c0b","695":"bc9b3258","722":"a2120637","779":"2fb69451","977":"f7cfbec2","997":"cb678bea"}[chunkId] + ".chunk.js";
};